import NprService from './service';
import { GetNprResponseData } from './types';

export const NPR_QUERY_KEYS = {
  GET_NPR: 'GET_NPR',
};

export class NoPermitRequiredQueries {
  public static readonly getNpr = async (
    projectID: number,
    requestID: number,
    version: number
  ): Promise<GetNprResponseData> => {
    const { data } = await NprService.getNpr(projectID, requestID, version);
    return data;
  };
}
